import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import {
  MdMoreVert,
  MdOutlineRemoveRedEye,
  MdOutlineEdit,
  MdDelete,
} from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";

export default function MasterCompanyTable({
  data,
  onDelete,
  onRefresh,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  viewButton,
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      setOpenUpward(spaceBelow < 150);
      setOpenDropdownId(rowId);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header text-gray-800">
            <tr>
              <th className="w-12 text-center">
                <input
                  type="checkbox"
                  className="table-checkbox"
                  onChange={onSelectAll}
                  checked={
                    data.length > 0 && selectedRows.length === data.length
                  }
                />
              </th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Contact</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No master companies found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowId = item._id || index;
                const isChecked = selectedRows.includes(rowId);
                const isMenuOpen = openDropdownId === rowId;

                return (
                  <tr key={rowId} className="custom-table-row">
                    <td className="custom-table-cell text-center">
                      <input
                        type="checkbox"
                        className="table-checkbox"
                        checked={isChecked}
                        onChange={() => onSelectRow(rowId)}
                      />
                    </td>

                    <td className="custom-table-cell">
                      {item.masterCompanyLogo ? (
                        <img
                          src={getImageUrl(item.masterCompanyLogo)}
                          alt={item.masterCompanyName}
                          className="table-logo"
                        />
                      ) : (
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-500">
                          N/A
                        </div>
                      )}
                    </td>

                    <td className="custom-table-cell font-medium text-gray-800">
                      {item.masterCompanyName || "N/A"}
                    </td>
                    <td className="custom-table-cell col-contact">
                      <div className="flex flex-col">
                        <span>{item.masterCompanyEmail || "N/A"}</span>
                        <span className="text-xs">
                          {item.masterCompanyMobileCountryCode
                            ? `${item.masterCompanyMobileCountryCode} ${item.masterCompanyMobile} `
                            : "N/A"}
                        </span>
                      </div>
                    </td>

                    {/* Action Dropdown Cell */}

                    <td className="custom-table-cell relative text-center">
                      <button
                        onClick={(e) => handleToggleMenu(e, rowId)}
                        className="action-menu-btn"
                      >
                        <MdMoreVert className="text-lg text-gray-800" />
                      </button>

                      {isMenuOpen && (
                        <div
                          ref={dropdownRef}
                          className={`action-dropdown-menu ${
                            openUpward ? "menu-bottom" : "menu-top"
                          }`}
                        >
                          <button
                            onClick={() => {
                              setOpenDropdownId(null);
                              viewButton(item);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdOutlineRemoveRedEye className="text-base" />
                            View
                          </button>

                          <div className="action-dropdown-divider" />

                          <Link
                            to={`/admin/master/edit/${item._id}`}
                            onClick={() => setOpenDropdownId(null)}
                            className="action-dropdown-item"
                          >
                            <MdOutlineEdit className="text-base" />
                            Edit
                          </Link>

                          <div className="action-dropdown-divider" />

                          <button
                            onClick={() => {
                              setOpenDropdownId(null);
                              setDeleteId(item._id);
                            }}
                            className="action-dropdown-item item-danger"
                          >
                            <MdDelete className="text-base" />
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Master Company"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      /> */}

      <ConfirmModal
        open={Boolean(deleteId)}
        title="Are you sure?"
        message="You are about to delete this master company. This action cannot be undone."
        confirmText="Yes, Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(false)}
      />
    </>
  );
}
